import { render, staticRenderFns } from "./LabelVariantOutline.vue?vue&type=template&id=323aff62"
import script from "./LabelVariantOutline.vue?vue&type=script&lang=js"
export * from "./LabelVariantOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports